
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stud/[parent]/[uid]",
      function () {
        return require("private-next-pages/stud/[parent]/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stud/[parent]/[uid]"])
      });
    }
  